@if (showHeader) {
  <div class="configuration-wizard-header">
    <h5 class="odx-title-5">{{ title }}</h5>
  </div>
}

<odx-content-box
  class="monitoring-overview-content flex-column w-100"
  [class.h-100]="fullHeight"
  [class.scroll]="fullHeight"
  [class.wizard-overview]="showHeader"
  odxLayout="flex"
>
  @if (sections.length) {
    <odx-accordion multiple="true" class="bottom-border monitoring-overview-accordion">
      @for (section of sections; track $index) {
        <odx-accordion-item [expanded]="true">
          <odx-accordion-item-title odxLayout="flex" class="space-between">
            <span>{{ section.title }}</span>
          </odx-accordion-item-title>
          <app-monitoring-grouped-parts-table [rows]="section.rows" [showCategory]="showCategory" />
        </odx-accordion-item>
      }
    </odx-accordion>
  } @else {
    <p i18n="@@monitoring.overview.noData">Keine Daten zum Anzeigen vorhanden</p>
  }
</odx-content-box>
